import { daysShortcuts } from './dates';

export const emptyOpenHours = daysShortcuts.reduce((days, day) => ({ ...days, [day]: null }));
